module.exports = __webpack_public_path__ + "static/iprights.0392939b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iprights.png
// module id = 1155
// module chunks = 213534597649335